import { Injectable } from '@angular/core';
import { WorldpayDataDto } from '../models/dto';

@Injectable({
  providedIn: 'root'
})
export class WorldPayUrlService {
  public getPaymentUrl(worldPayDataDto: WorldpayDataDto): string {
    let paymentUrl = this.getBasePaymentUrl(worldPayDataDto);
    paymentUrl = paymentUrl.concat('&name=', worldPayDataDto.Name);
    paymentUrl = paymentUrl.concat('&postcode=', worldPayDataDto.PostCode);
    paymentUrl = paymentUrl.concat('&tel=', worldPayDataDto.Tel);
    paymentUrl = paymentUrl.concat('&operationId=', worldPayDataDto.OperationId);
    paymentUrl = paymentUrl.concat('&hideCurrency=', worldPayDataDto.HideCurrency.toString());

    return paymentUrl;
  }

  public getFeesUrl(worldPayDataDto: WorldpayDataDto): string {
    let feesUrl = this.getBasePaymentUrl(worldPayDataDto);
    feesUrl = feesUrl.concat('&MC_valuationFee=', worldPayDataDto.ValuationFee.toString());
    feesUrl = feesUrl.concat('&MC_valuationFeeDprId=', worldPayDataDto.ValuationFeDprId);
    feesUrl = feesUrl.concat('&MC_bookingFee=', worldPayDataDto.BookingFee.toString());
    feesUrl = feesUrl.concat('&MC_bookingFeeDprId=', worldPayDataDto.BookingFeeDprId);

    return feesUrl;
  }

  private getBasePaymentUrl(worldPayDataDto: WorldpayDataDto): string {
    const baseWorldPayUrl = worldPayDataDto.Url;
    let worldPayUrl = baseWorldPayUrl.concat('?instId=', worldPayDataDto.InstId);
    worldPayUrl = worldPayUrl.concat('&cartId=', worldPayDataDto.CartId);
    worldPayUrl = worldPayUrl.concat('&currency=', worldPayDataDto.Currency);
    worldPayUrl = worldPayUrl.concat('&testMode=', worldPayDataDto.TestMode);
    worldPayUrl = worldPayUrl.concat('&desc=', encodeURIComponent(worldPayDataDto.Description));
    worldPayUrl = worldPayUrl.concat(
      '&shopperAdditionalAccountNumber=',
      worldPayDataDto.ShopperAdditionalAccountNumber
    );
    worldPayUrl = worldPayUrl.concat('&country=', worldPayDataDto.Country);
    worldPayUrl = worldPayUrl.concat('&MC_paymentGUID=', worldPayDataDto.PaymentGuid);
    worldPayUrl = worldPayUrl.concat('&accId1=', worldPayDataDto.MerchantId);
    worldPayUrl = worldPayUrl.concat('&amount=', worldPayDataDto.Amount.toString());
    worldPayUrl = worldPayUrl.concat('&shopperAdditionalLastName=', worldPayDataDto.ShopperAdditionalLastName);
    worldPayUrl = worldPayUrl.concat('&shopperAdditionalBirthDate=', worldPayDataDto.ShopperAdditionalBirthDate);
    worldPayUrl = worldPayUrl.concat('&shopperAdditionalPostalCode=', worldPayDataDto.ShopperAdditionalPostalCode);
    worldPayUrl = worldPayUrl.concat('&email=', worldPayDataDto.Email);
    worldPayUrl = worldPayUrl.concat('&signature=', worldPayDataDto.Signature);

    return worldPayUrl;
  }
}
